var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "survey" }, [
    _c(
      "ul",
      { staticClass: "choices" },
      _vm._l(_vm.choices, function(choice) {
        return _c(
          "li",
          {
            key: choice.identifier,
            class: {
              selected: _vm.selected(choice.identifier),
              popular: choice.is_most_popular
            },
            on: {
              click: function($event) {
                return _vm.chosen(choice.identifier)
              }
            }
          },
          [
            choice.image_url
              ? _c("img", {
                  attrs: { src: choice.image_url, alt: choice.title }
                })
              : _vm._e(),
            _vm._v(" "),
            choice.is_most_popular
              ? _c("span", { staticClass: "most-popular-badge" }, [
                  _vm._v("Most popular")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "text-wrapper",
                attrs: { "data-testid": "nux_step_survey_choice" }
              },
              [
                choice.title
                  ? _c("strong", [_vm._v(_vm._s(choice.title))])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { domProps: { innerHTML: _vm._s(choice.text) } })
              ]
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }